import React from 'react';
import { Link } from 'react-scroll';

const HomeInfo = () => {
    return (
        <section id="information" className="block">
            <div className="wrapper">
                <div className="row no-gutters information-items">
                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <div className="information information-color-2">
                            <div className="information-icon">
                                <i className="fas fa-phone-alt"></i>
                            </div>

                            <h4 className="information-t-head">How to Contact Us?</h4>

                            <div className="information-description">
                                <p>Please send us an email if you need to get in contact with us:</p>
                            </div>

                            <div className="information-btn">
                                <a title="Email Us" className="btn btn-sm btn-link btn-line p-0 border-0 min-w-auto link-no-space text-uppercase scroll-to-id" href="mailto:info@botanyphysio.co.nz">info@botanyphysio.co.nz</a>
                            </div>

                            <div className="information-description">
                                <br /> <br /> <p>Or alternatively call us:</p>
                            </div>

                            <div className="information-btn">
                                <a title="Phone us" className="btn btn-sm btn-link btn-line p-0 border-0 min-w-auto link-no-space text-uppercase" href="tel:028-851-48965">028 851 48965</a>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <div className="information information-color-3 information-icon-margin">
                            <div className="information-icon">
                                <i className="fas fa-map-marker-alt"></i>
                            </div>

                            <h4 className="information-t-head">Where Are We?</h4>

                            <div className="information-description">
                                <p>We are located at 41 Meadowlands Drive, Somerville, Auckalnd 2014. Please use the main club entrance. We offer free carparking with mobility access and spaces.</p>
                            </div>

                            <div className="information-btn">
                                <Link to="google-maps" title="See on map" className="btn btn-sm btn-link btn-line p-0 border-0 min-w-auto link-no-space text-uppercase scroll-to-id" href="#google-maps">See on map</Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <div className="information information-color-2">
                            <div className="information-icon">
                                <i className="far fa-calendar-alt"></i>
                            </div>

                            <h4 className="information-t-head">Opening Hours</h4>

                            <div className="information-description">
                                <p>Open between Monday to Friday with various appointments times avaliable.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeInfo;
